// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Py2x","col":"styles_col__4obwm"};